<div class="container-fluid">
  <page-header-breadcrumb
  [pageTitleValue]="pageTitle"
  [pageLinkValue]="'/geo/areas'"
  [currentPageValue]="editMode ? 'Edit Area' : 'Add Area'"
></page-header-breadcrumb>
  <div class="card mb-4">
    <div class="card-body">
      <form [formGroup]="addAreaForm" (ngSubmit)="onAddAreaSubmit()">
        <div class="row">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="area-en-name">
                Area EN Name
              </label>
              <input
                class="form-control"
                id="area-en-name"
                formControlName="enAreaName"
                placeholder="Area Name"
                type="text"
              />
              <div
                *ngIf="
                  (isSubmited || addAreaForm.controls.enAreaName.dirty) &&
                  addAreaForm.controls.enAreaName.errors
                "
                class="input-errors"
              >
                <p *ngIf="addAreaForm.controls.enAreaName.errors.required">
                  This field is required!
                </p>
                <p *ngIf="addAreaForm.controls.enAreaName.errors.pattern">
                  This field accept only english characters!
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="area-ar-name">
                Area AR Name
              </label>
              <input
                class="form-control"
                id="area-ar-name"
                formControlName="arAreaName"
                placeholder="Area Arabic Name"
                type="text"
              />
              <div
                *ngIf="
                  (isSubmited || addAreaForm.controls.arAreaName.dirty) &&
                  addAreaForm.controls.arAreaName.errors
                "
                class="input-errors"
              >
                <p *ngIf="addAreaForm.controls.arAreaName.errors.required">
                  This field is required!
                </p>
                <p *ngIf="addAreaForm.controls.arAreaName.errors.pattern">
                  This field accept only arabic characters!
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="row align-items-center">
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-control-label" for="area-city">
                Choose city
              </label>
              <select
                formControlName="areaCity"
                class="form-control"
                id="area-city"
              >
                <option *ngFor="let city of cities" [value]="city.id">
                  {{ city.enName }}
                </option>
              </select>
              <div
                *ngIf="
                  (isSubmited || addAreaForm.controls.areaCity.dirty) &&
                  addAreaForm.controls.areaCity.errors
                "
                class="input-errors"
              >
                <p *ngIf="addAreaForm.controls.areaCity.errors.required">
                  This field is required!
                </p>
              </div>
            </div>
          </div>
          <div class="col d-flex align-items-center">
            <label class="mr-6 mb-0" for="active-check">Active ?</label>
            <label class="custom-toggle custom-toggle-default">
              <input
                checked="checked"
                type="checkbox"
                id="active-check"
                formControlName="areaActiveCheck"
              />
              <span
                class="custom-toggle-slider rounded-circle"
                data-label-off="No"
                data-label-on="Yes"
              >
              </span>
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col btns-block">
            <button
              class="btn btn-primary"
              type="submit"
              [disabled]="addAreaForm.invalid"
            >
              {{ editMode ? "Edit" : "Save" }}
            </button>
            <button
              class="btn btn-outline-danger"
              type="button"
              [routerLink]="'/geo/areas'"
            >
              Cancel
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
